import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import * as React from "react";
import { formatPercentTr } from "../../../Helper/FormatDecimalTr";
import { AircraftScoreModel } from "../Model/AiReliabilityModels";
import { getRiskColor, getRiskLabel } from "./CustomerScoreCard";

interface AircraftScoresTableProps {
  scores: AircraftScoreModel[];
  loading: boolean;
}

const AircraftScoresTable: React.FC<AircraftScoresTableProps> = ({ scores, loading }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!scores || scores.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary" style={{ padding: 16 }}>
        Bu müşteri için uçak bazlı skor verisi bulunamadı.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow style={{ backgroundColor: "#f5f5f5" }}>
            <TableCell>
              <strong>Kuyruk Kodu</strong>
            </TableCell>
            <TableCell>
              <strong>Skor</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Saat Sap. %</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Cycle Sap. %</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Toplam Kayıt</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Yüksek Risk</strong>
            </TableCell>
            <TableCell>
              <strong>AI Özeti</strong>
            </TableCell>
            <TableCell>
              <strong>Son Güncelleme</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {scores.map(row => {
            const color = getRiskColor(row.score);
            return (
              <TableRow key={row.id} hover>
                <TableCell>
                  <strong>{row.acRegistration}</strong>
                </TableCell>
                <TableCell>
                  <Chip
                    label={`${row.score} — ${getRiskLabel(row.score)}`}
                    size="small"
                    style={{ backgroundColor: color, color: "#fff", fontWeight: 600 }}
                  />
                </TableCell>
                <TableCell align="right">{formatPercentTr(row.avgTimeDeviationPct)}</TableCell>
                <TableCell align="right">{formatPercentTr(row.avgCycleDeviationPct)}</TableCell>
                <TableCell align="right">{row.totalEntries}</TableCell>
                <TableCell align="center">
                  {row.highRiskEntryCount > 0 ? (
                    <Tooltip title={`${row.highRiskEntryCount} yüksek riskli kayıt`}>
                      <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 4 }}>
                        <Warning style={{ color: "#f44336", fontSize: 18 }} />
                        <Typography variant="caption" style={{ color: "#f44336", fontWeight: 600 }}>
                          {row.highRiskEntryCount}
                        </Typography>
                      </Box>
                    </Tooltip>
                  ) : (
                    <Typography variant="caption" color="textSecondary">
                      —
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  {row.aiSummary ? (
                    <Tooltip title={row.aiSummary} placement="top" arrow>
                      <Typography
                        variant="caption"
                        style={{
                          display: "block",
                          maxWidth: 200,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          cursor: "help",
                        }}
                      >
                        {row.aiSummary}
                      </Typography>
                    </Tooltip>
                  ) : (
                    <Typography variant="caption" color="textSecondary">
                      —
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="textSecondary">
                    {row.lastCalculatedAt ? new Date(row.lastCalculatedAt).toLocaleString("tr-TR") : "—"}
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AircraftScoresTable;
